import { AuditEntityType } from '@sr/dto';
import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { auditApi } from './api';

const makeTagId = (entityType: AuditEntityType, entityId: number) => `${entityType}-${entityId}`;

export const invalidateEntityAudit = (dispatch: Dispatch<UnknownAction>, entityType: AuditEntityType, entityId?: number | null) => {
  if (!entityId && entityId !== 0) return;
  dispatch(
    auditApi.util.invalidateTags([
      { type: 'AuditLog', id: makeTagId(entityType, entityId) },
    ]),
  );
};
